import localFont from "next/font/local";

export const albert = localFont({
  src: [
    {
      path: "./albert-sans-v4-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./albert-sans-v4-latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./albert-sans-v4-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-albert",
  fallback: ["Arial", "sans-serif"],
  adjustFontFallback: "Arial",
});

export const fonts = {
  albert,
};
